import SpecialtiesForm from './SpecialtiesForm';

export default SpecialtiesForm;
